class exports.InserterDialogHandler extends DialogHandler
    constructor: () ->
        @data = null
        super()

    init: () ->
        @layoutUrl = 'backend/admin/inserter/load-layout-dialog'
        @classes = 'large_dialog'

        @createDialog()

    afterLoadLayout: (selector, data) ->
        ths = this
        @openDialog()

        @dialog.find('.save-btn').bind 'click', () =>
            $(@parent.layoutSelector).find('#upload_form input[name="hdn_forreal"]').val(true)
            $(@parent.layoutSelector).find('#btn_start_upload').click()

        @loadData @data

        @dialog.find('#hdi_exception_btn').bind 'click', () =>
            @dialog.find('.modal-body div').show()
            $(this).hide()

    buildJson: (node) ->
        json = []
        numChildren = 0
        titleChildren = null

        for key, val of node
            obj = {}

            if val instanceof Array or val instanceof Object
                children = @buildJson val
                obj.children = children[1]

                title = children[0]
                if not title?
                    title = Object.keys(val).length
                obj.data = key + ': [ ' + title + ' ]'

            else
                obj.data = key + ': ' + val
                if ++numChildren is 1
                    titleChildren = val
                else
                    titleChildren = null

            json.push obj
        return [ titleChildren, json ]

    buildJsTree: (elem, json) ->
        elem.jstree
            plugins: [ 'themes', 'json_data', 'ui' ]
            core:
                animation: '200'
            json_data:
                data: json
                progressive_render: true
            themes:
                url: '/css/jstree_themes/default/style.css'
                dots: false
                icons: false
        .bind 'click.jstree', (event, data) ->
            if $(event.target).prop('tagName') is 'A'
                elem.jstree 'toggle_node', event.target

    loadData: (data) ->

        if typeof(data) is 'string'
            @dialog.find('.modal-body div').toggle()
            @dialog.find('#hdi_exception .btn').hide()
            @dialog.find('#hdi_exception_content').html(data)

        else
            if data.exception?
                @dialog.find('.modal-body div').toggle()
                @dialog.find('#hdi_exception_content').html('<pre>' + data.exception + '</pre>')

            # Format json object correctly
            json = {}
            for key, node of data
                json[key] = @buildJson(node)

            if @type is 'as400'
                @buildJsTree @dialog.find('#contracts_tree'), json['contracts']
                @buildJsTree @dialog.find('#hybrids_tree'), json['hybrids']
                @buildJsTree @dialog.find('#irrigation_tree'), json['irrigation']
                @buildJsTree @dialog.find('#machinery_tree'), json['machinery']

                @buildJsTree @dialog.find('#fields_tree'), json['fields']
                @buildJsTree @dialog.find('#plans_tree'), json['plans']

            else if @type is 'testplots'
                @buildJsTree @dialog.find('#fields_tree'), json['fields']
                @buildJsTree @dialog.find('#hybrids_tree'), json['hybrids']
                @buildJsTree @dialog.find('#traits_tree'), json['traits']

            else if @type is 'users'
                @buildJsTree @dialog.find('#users_failed_tree'), json['failed']
                @buildJsTree @dialog.find('#users_succeeded_tree'), json['succeeded']

            @dialog.find('#ptime').html data.ptime + ' ms'
            @dialog.find('#ttime').html data.ttime + ' ms'


            for message in data.messages
                @dialog.find('#hdi_messages').append '<p>' + message + '</p>'
